module.exports = __webpack_public_path__ + "img/pse.4ad9d7c.svg";